import { Box, BoxProps, type ContainerProps, type StackProps } from "@mui/material";
import { FC } from "react";
import { SalifyLinkV2 } from "../ui/link/link";
import { extractYoutubeVideoId } from "src/lib/utils/youtube-privacy";
import type { PositionAbsouteType } from "src/lib/utils/types";

interface SalifyBannerWrapperYoutubeProps {
  youtubeUrl: string;
  link?: any;
  content?: {
    position: PositionAbsouteType;
    stackProps: StackProps;
    containerProps: ContainerProps;
    components: any[];
  };
  cssProps?: BoxProps;
}

const SalifyBannerWrapperYoutube: FC<SalifyBannerWrapperYoutubeProps> = (props) => {
  const raw = props.youtubeUrl.trim();
  const videoId = extractYoutubeVideoId(raw) ?? (/^[a-zA-Z0-9_-]{11}$/.test(raw) ? raw : null);
  if (!videoId) {
    return (
      <SalifyLinkV2 href={props.link}>
        <Box {...props.cssProps} />
      </SalifyLinkV2>
    );
  }
  const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&controls=0&loop=1&playlist=${videoId}&modestbranding=1&rel=0&showinfo=0&playsinline=1`;

  return (
    <SalifyLinkV2 href={props.link}>
      <Box
        position="relative"
        height="70vh"
        sx={{
          ":hover iframe": {
            transform: "scale(1.02)",
          },
        }}
        {...props.cssProps}
      >
        <Box
          component="div"
          overflow="hidden"
          sx={{
            position: "relative",
            height: "100%",
            width: "100%",
          }}
        >
          <Box
            component="iframe"
            title="YouTube video"
            src={embedUrl}
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: 0,
              transition: "transform 0.3s ease-in-out",
              pointerEvents: "none", // Disable interaction with the video
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </Box>
      </Box>
    </SalifyLinkV2>
  );
};

SalifyBannerWrapperYoutube.displayName = "SalifyBannerWrapperYoutube";

export default SalifyBannerWrapperYoutube;
